

























































import '../../styles/order.less'
import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/components/public/Search.vue'
import Partner from '@/components/public/Partner.vue'
import OrderTable from './OrderTable.vue'
import RecycleBin from './RecycleBin.vue'
import orderApi from '@/api/orderApi'
import router from '@/router'
import NoData from '@/components/ui/NoData.vue'
import listApi from '@/api/listApi'
@Component({
  components: {
    Search,
    Partner,
    OrderTable,
    RecycleBin,
    NoData
  }
})
export default class OrderIndex extends Vue {

  @Prop({ default: 9 }) public state: number

  protected prompt: string = '请输入商品名称或订单号搜索'
  protected status: any[] = [
    { name: '所有订单', value: 9 },
    { name: '待付款', value: 0 },
    { name: '待实施', value: 1 },
    { name: '已实施', value: 3 },
    { name: '待审核', value: 4 },
    { name: '已关闭', value: 8 }
  ]

  protected req: any = {
    orderStatusEnum: this.status[0].value,
    page: 1,
    size: 10,
    searchWord: '',

  }

  protected res: any = {
    total: 0,
    list: [],
    partnerList: []

  }

  public mounted() {
    this.req.orderStatusEnum = this.state
    this.getOrderList()
    this.getBoutique()
  }

  public beforeRouteUpdate(to: any, from: any, next: any) {
    if (to.query.state !== from.query.state) {
      this.req.orderStatusEnum = to.query.state
      this.getOrderList()
    }
    next()
  }

  protected getOrderList() {
    orderApi.getOrderList(this.req).then((res) => {
      if (res.code === 200) {
        this.res.list = res.data.content
        this.res.total = res.data.totalElements * 1 || 0
        this.req.page = res.data.number
        this.req.searchWord = ''
      }
    })
  }

  protected toggleStatus(item: any) {
    this.req.page = 1
    router.push({ name: this.$route.name, query: { state: item.value } })
  }

  protected changePage(page: any) {
    this.req.page = page
    this.getOrderList()
  }

  protected cancel(item: any) {
    const that = this
    this.$confirm({
      title: '你即将取消当前订单',
      content: '订单取消后将不能结束本次购买，你还要继续吗？',
      okText: '继续',
      cancelText: '取消',
      onOk() {
        orderApi.cancelOrder({
          orderCode: item.orderCode
        }).then((res) => {
          if (res.code === 200 && res.data == true) {
            that.getOrderList()
            that.$message.info('取消成功')
          }
        })
      },
    });
  }

  protected delOrder(item: any) {
    const that = this
    this.$confirm({
      title: '确定要删除订单吗',
      content: '删除后可在订单回收站还原',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        orderApi.delOreder({
          orderCode: item.orderCode
        }).then((res) => {
          if (res.code === 200) {
            that.getOrderList()
            that.$message.info('删除成功')
          }
        })
      },
    });
  }

  protected search(item: any) {
    this.req.searchWord = item
    this.getOrderList()
  }

  // 从子组件获取状态然后掉接更改页面状态
  protected goChange(state: number) {
    if (state === 0) {
      this.getOrderList()
    }
  }

   // 下边资源精选
  protected getBoutique(): void {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'ORDER_BOTTOM',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.res.partnerList = res.data
        console.log(res.data)
      }
    })
  }
}
